import { render, staticRenderFns } from "./board_gold_view.vue?vue&type=template&id=c3c8ebe6&"
import script from "./board_gold_view.vue?vue&type=script&lang=js&"
export * from "./board_gold_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports